export default "__VITE_ASSET__B9OD_NTH__"